import { TransportationSetting } from "shared/components/transportation/transportation-setting";

export function TransportationPage() {
  return (
    <div className="website-config">
      <TransportationSetting />
    </div>
  );
}
